import { FEEDBACKTYPE_POSITIVE } from '../constants/feedbackConstants'
import { actions } from 'react-redux-toastr'
import { getErrorAction } from './errorMapper'
import { createReducer } from './reducerUtils'
import { mergeMap, map, catchError } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'

// Actions
const FEEDBACK_SHOW = 'FEEDBACK_SHOW'
const FEEDBACK_CANCEL = 'FEEDBACK_CANCEL'
const FEEDBACK_SUBMIT = 'FEEDBACK_SUBMIT'
export const FEEDBACK_SUBMIT_SUCCESS = 'FEEDBACK_SUBMIT_SUCCESS'
export const FEEDBACK_SUBMIT_FAILURE = 'FEEDBACK_SUBMIT_FAILURE'

// Action Creators
export const feedbackShow = (feedbackType) => ({ type: FEEDBACK_SHOW, payload: { feedbackType } })
export const feedbackCancel = () => ({ type: FEEDBACK_CANCEL })
export const feedbackSubmit = (comment, feedbackType) => ({ type: FEEDBACK_SUBMIT, payload: { comment, feedbackType } })
export const feedbackSubmitSuccess = () => ({ type: FEEDBACK_SUBMIT_SUCCESS })
export const feedbackSubmitFailure = payload => ({ type: FEEDBACK_SUBMIT_FAILURE, payload, error: true })

// Epics
export const feedbackSubmitEpic = (action$, state$, { vapiClient }) =>
  action$.pipe(
    ofType(FEEDBACK_SUBMIT),
    mergeMap(({ payload }) => {
      let userInfo = state$.value.userInfo
      let like = payload.feedbackType === FEEDBACKTYPE_POSITIVE
      return vapiClient
        .postFeedback(payload.comment, like, userInfo).pipe(
          map(() => feedbackSubmitSuccess()),
          catchError(error => of(getErrorAction(error, feedbackSubmitFailure)))
        )
    })
  )

export const feedbackSubmitSuccessEpic = (action$, state$, { localize }) =>
  action$.pipe(
    ofType(FEEDBACK_SUBMIT_SUCCESS),
    map(() => {
      const feedbackSuccessToast = {
        type: 'success',
        message: localize(state$.value.resources, 'common.Msg_Feedback'),
        options: {
          removeOnHover: true
        }
      }

      return actions.add(feedbackSuccessToast)
    })
  )


// Reducer
const feedbackShowReducer = (state, { feedbackType }) => ({ ...state, showFeedback: true, feedbackType: feedbackType })
const feedbackHideReducer = (state) => ({ ...state, showFeedback: false })

const feedbackHandlerMapping = {
  [FEEDBACK_SHOW]: feedbackShowReducer,
  [FEEDBACK_CANCEL]: feedbackHideReducer,
  [FEEDBACK_SUBMIT_SUCCESS]: feedbackHideReducer
}

const feedbackInitialState = { feedbackType: FEEDBACKTYPE_POSITIVE, showFeedback: false }
export const feedbackReducer = createReducer(feedbackInitialState, feedbackHandlerMapping)

export default feedbackReducer



// WEBPACK FOOTER //
// ./src/store/feedback.js